import React, {useState} from "react";
import AutocompleteInput, {ISelectItem} from "@source/components/UI/inputs/autocompleteInput/autocompleteInput";
import Chip from "@source/components/UI/chip/chip";
import {normalizeConsentIds} from "@source/api/models/consentHelpers";
import {SignerPerson, signerLabel, uniqueSignerPeople} from "./consentStepsShared";
import styles from "./consentSteps.module.scss";

export const PeoplePicker = ({id, label, placeholder, people, selected, disabled, onAdd, onRemove}: {
  id: string;
  label: string;
  placeholder: string;
  people: SignerPerson[];
  selected: string[];
  disabled: boolean;
  onAdd: (id: string) => void;
  onRemove: (id: string) => void;
}) => {
  const [search, setSearch] = useState("");
  const uniquePeople = uniqueSignerPeople(people);
  const selectedIds = normalizeConsentIds(selected);
  const available = uniquePeople.filter((person) => !selectedIds.includes(person._id));
  const selectedPeople = selectedIds
    .map((personId) => uniquePeople.find((person) => person._id === personId))
    .filter((person): person is SignerPerson => Boolean(person));
  const items: ISelectItem[] = available.map((person) => ({id: person._id, value: person._id, title: signerLabel(person)}));

  return <section className={styles.section}>
    <AutocompleteInput
      id={id}
      label={label}
      required
      placeholder={placeholder}
      value={null}
      items={items}
      inputItems={items}
      inputValue={search}
      disabled={disabled || !available.length}
      handleChange={(_, person) => {
        if (person) onAdd(person.value);
        setSearch("");
      }}
      onInputChange={(_, value) => setSearch(value)}
    />
    {selectedPeople.length ? <div className={styles.selectedPeople}>
      {selectedPeople.map((person) => <Chip key={person._id} id={person._id} text={signerLabel(person)} onDelete={disabled ? undefined : onRemove}/>)}
    </div> : null}
    {!people.length ? <p>No eligible people are available.</p> : null}
  </section>;
};
